// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root {
  width: 100%;
  height: 100%;
}
body {
  margin: 0px;
  font-family: Poppins, 'Poppins Fallback';
  color:#102B4C;
}

* {
  font-family: Poppins, 'Poppins Fallback';
}

a {
  color:#102B4C;
  text-decoration: none;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  margin: 0;
}

h1 {
  font-size: 48px;
  line-height: 48px;
  font-weight: 700;
}

h2 {
  font-size: 36px;
  line-height: 36px;
  font-weight: 700;
}

h3 {
  font-size: 24px;
  line-height: 28px;
  font-weight: 600;
}

h4 {
  font-size: 18px;
  line-height: 18px;
}
h5 {
  font-size: 16px;
  line-height: 20px;
}
h6 {
  font-size: 12px;
  line-height: 18px;
}

p {
  margin: 0;
  font-size: 14px;
}

ul {
  margin: 0;
  font-size: 14px;
}

@media only screen and (max-width: 600px) {
  h1 {
    font-size: 38px;
    line-height: 38px;
    font-weight: 700;
  }

  h2 {
    font-size: 32px;
    line-height: 32px;
    font-weight: 700;
  }

  h3 {
    font-size: 18px;
    line-height: 18px;
    font-weight: 600;
  }

  h4 {
    font-size: 16px;
    line-height: 22px;
  }
  h5 {
    font-size: 14px;
    line-height: 20px;
  }
  h6 {
    font-size: 12px;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
}


.swiper-button-next, .swiper-button-prev {
  color: var(--tb-color-ink, #102B4C) !important;
  background-color: var(--tb-color-primary, #FFD568) !important ;
  border: var(--tb-border, 2px solid #102B4C);
  border-radius: var(--tb-radius-pill, 999px);
  box-shadow: var(--tb-shadow-sm);
  padding: 4px;
  height: 40px !important;
  width: 40px !important;
}

.swiper-button-next:after, .swiper-button-prev:after {
  font-size: 18px !important;
  font-weight: 600 !important;
}

.swiper-button-prev:after {
  padding-right: 2px;
}

.swiper-button-next:after {
  padding-left: 2px;
}

.swiper-container{
  height: 100%;
  max-height: 100vw;
  min-height: 0;
  min-width: 0;
  max-width: 100vw;
  width: 100%;
  overflow: hidden;
}

.swiper-slide{
  width: auto;
  flex-shrink: 0;
  display: block;
  height: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
}

.swiper-wrapper{
  max-height: 100%;
  height: 100%t;
  display: flex;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--tb-color-divider, #E6EAF0);
  border-radius: 8px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--tb-color-ink-muted, #4A5B75);
  border-radius: 8px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--tb-color-ink, #102B4C);
}

@-webkit-keyframes sk-bouncedelay {
  35% { -webkit-transform: translate(0px, -8px) }
  0%, 60%, 100% { -webkit-transform: translate(0px, 0px) }
}

@keyframes sk-bouncedelay {
  35% {
    -webkit-transform: translate(0px, -8px);
    transform: translate(0px, -8px);
  } 0%, 60%, 100% {
    -webkit-transform: translate(0px, 0px);
    transform: translate(0px, 0px);
  }
}

@keyframes recording-spinner {
  20%, 80% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.Toastify__toast {
  border-radius: var(--tb-radius-md, 16px) !important;
}

.swiper-container-horizontal>.swiper-pagination-bullets {
  bottom: -6px !important;
}

.swiper-pagination-bullet {
  width: 10px !important;
  height: 10px !important;
  border: 1.5px solid var(--tb-color-ink, #102B4C);
  background: var(--tb-color-surface, #fff) !important;
  opacity: 1 !important;
}

.swiper-pagination-bullet-active {
  width: 22px !important;
  border-radius: 5px !important;
  background: var(--tb-color-primary, #FFD568) !important;
}

.MuiTouchRipple-root {
  display: none;
}

.Mui-focused: {
  color: black;
}

.MuiPaper-root {
  border-radius: 12px !important;
}

.MuiMenuItem-root {
  font-size: 14px !important;
}
`, "",{"version":3,"sources":["webpack://./public/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;AACF;;;AAGA;EACE,8CAA8C;EAC9C,8DAA8D;EAC9D,2CAA2C;EAC3C,2CAA2C;EAC3C,+BAA+B;EAC/B,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA,UAAU;AACV;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,wCAAwC;AAC1C;;AAEA;EACE,MAAM,wCAAwC;EAC9C,gBAAgB,uCAAuC;AACzD;;AAEA;EACE;IACE,uCAAuC;IACvC,+BAA+B;EACjC,EAAE;IACA,sCAAsC;IACtC,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gDAAgD;EAChD,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["html, body, #root {\n  width: 100%;\n  height: 100%;\n}\nbody {\n  margin: 0px;\n  font-family: Poppins, 'Poppins Fallback';\n  color:#102B4C;\n}\n\n* {\n  font-family: Poppins, 'Poppins Fallback';\n}\n\na {\n  color:#102B4C;\n  text-decoration: none;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n  margin: 0;\n}\n\nh1 {\n  font-size: 48px;\n  line-height: 48px;\n  font-weight: 700;\n}\n\nh2 {\n  font-size: 36px;\n  line-height: 36px;\n  font-weight: 700;\n}\n\nh3 {\n  font-size: 24px;\n  line-height: 28px;\n  font-weight: 600;\n}\n\nh4 {\n  font-size: 18px;\n  line-height: 18px;\n}\nh5 {\n  font-size: 16px;\n  line-height: 20px;\n}\nh6 {\n  font-size: 12px;\n  line-height: 18px;\n}\n\np {\n  margin: 0;\n  font-size: 14px;\n}\n\nul {\n  margin: 0;\n  font-size: 14px;\n}\n\n@media only screen and (max-width: 600px) {\n  h1 {\n    font-size: 38px;\n    line-height: 38px;\n    font-weight: 700;\n  }\n\n  h2 {\n    font-size: 32px;\n    line-height: 32px;\n    font-weight: 700;\n  }\n\n  h3 {\n    font-size: 18px;\n    line-height: 18px;\n    font-weight: 600;\n  }\n\n  h4 {\n    font-size: 16px;\n    line-height: 22px;\n  }\n  h5 {\n    font-size: 14px;\n    line-height: 20px;\n  }\n  h6 {\n    font-size: 12px;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n  }\n}\n\n\n.swiper-button-next, .swiper-button-prev {\n  color: var(--tb-color-ink, #102B4C) !important;\n  background-color: var(--tb-color-primary, #FFD568) !important ;\n  border: var(--tb-border, 2px solid #102B4C);\n  border-radius: var(--tb-radius-pill, 999px);\n  box-shadow: var(--tb-shadow-sm);\n  padding: 4px;\n  height: 40px !important;\n  width: 40px !important;\n}\n\n.swiper-button-next:after, .swiper-button-prev:after {\n  font-size: 18px !important;\n  font-weight: 600 !important;\n}\n\n.swiper-button-prev:after {\n  padding-right: 2px;\n}\n\n.swiper-button-next:after {\n  padding-left: 2px;\n}\n\n.swiper-container{\n  height: 100%;\n  max-height: 100vw;\n  min-height: 0;\n  min-width: 0;\n  max-width: 100vw;\n  width: 100%;\n  overflow: hidden;\n}\n\n.swiper-slide{\n  width: auto;\n  flex-shrink: 0;\n  display: block;\n  height: 100%;\n  max-height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.swiper-wrapper{\n  max-height: 100%;\n  height: 100%t;\n  display: flex;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: var(--tb-color-divider, #E6EAF0);\n  border-radius: 8px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: var(--tb-color-ink-muted, #4A5B75);\n  border-radius: 8px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: var(--tb-color-ink, #102B4C);\n}\n\n@-webkit-keyframes sk-bouncedelay {\n  35% { -webkit-transform: translate(0px, -8px) }\n  0%, 60%, 100% { -webkit-transform: translate(0px, 0px) }\n}\n\n@keyframes sk-bouncedelay {\n  35% {\n    -webkit-transform: translate(0px, -8px);\n    transform: translate(0px, -8px);\n  } 0%, 60%, 100% {\n    -webkit-transform: translate(0px, 0px);\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes recording-spinner {\n  20%, 80% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n}\n\n.Toastify__toast {\n  border-radius: var(--tb-radius-md, 16px) !important;\n}\n\n.swiper-container-horizontal>.swiper-pagination-bullets {\n  bottom: -6px !important;\n}\n\n.swiper-pagination-bullet {\n  width: 10px !important;\n  height: 10px !important;\n  border: 1.5px solid var(--tb-color-ink, #102B4C);\n  background: var(--tb-color-surface, #fff) !important;\n  opacity: 1 !important;\n}\n\n.swiper-pagination-bullet-active {\n  width: 22px !important;\n  border-radius: 5px !important;\n  background: var(--tb-color-primary, #FFD568) !important;\n}\n\n.MuiTouchRipple-root {\n  display: none;\n}\n\n.Mui-focused: {\n  color: black;\n}\n\n.MuiPaper-root {\n  border-radius: 12px !important;\n}\n\n.MuiMenuItem-root {\n  font-size: 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
